import React from "react";
import ReactDOM from "react-dom/client";
import CheckListForm from "../components/CheckListForm";

export default () => {
  const element = document.getElementById("check-list-form");
  if (!element) return;

  if (!element.dataset.list) return;

  ReactDOM.createRoot(element).render(<CheckListForm initialItems={JSON.parse(element.dataset.list)} />);
};
